const styles = (theme) => ({
    buttonClear: {
        margin: theme.spacing(1, 1, 0, 0),
        float: "left",
    },
    buttonApply: {
        margin: theme.spacing(1, 1, 0, 0),
        float: "left",
    },
    subCards: {
        width: "100%",
        margin: theme.spacing(1, 1, 0, 1),
        padding: theme.spacing(2),
    },
});

export default styles;
